export default "__VITE_ASSET__CipD$dez__"